<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2022-12-26 11:32:25
 * @LastEditors: wanglixin wang1223634360@163.com
 * @LastEditTime: 2023-05-11 14:09:14
 * @FilePath: \VUE3\src\pages\jiaowu\views\cjxfgl\chengjiluru\addPopup.vue
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openAdd" :close-on-click-modal="false" :show-close="false"
      destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期">
              <el-select v-model="ruleForm.ksxqid" @change="xveqichaxvn(1)" style="width: 220px;" filterable>
                <el-option v-for="(item) in allXq" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试计划" prop="ksjhid"  :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select @change="xveqichaxvn(2)" v-model="ruleForm.ksjhid" style="width:220px" filterable>
                <el-option v-for="(item) in kaoshirenwu" :key="item.id" :label="item.ksmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="考试科目" prop="kmid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select @change="xveqichaxvn(3)" v-model="ruleForm.kmid" style="width:220px"
                filterable>
                <el-option v-for="(item) in kaoshikemu" :key="item.kskmid" :label="item.kskmmc" :value="item.kskmid" :disabled="!(item.lrcjfs == lrcjfsData.tongYiLuRu)"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考号/学号" prop="kh" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.kh" @blur="xvesheng" style="max-width:220px" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分数" prop="fs" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.fs" placeholder="分数" style="max-width:220px" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学生姓名:">
              {{xsxx.xm}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级:">
              {{xsxx.xzbmc}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学号:">
              {{xsxx.xh}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { actionPost, closeWindow, loadSelect, submitEditForm } from '@/api/common.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo.js'
import { ElMessageBox } from 'element-plus'

const props = defineProps({ openAdd: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const kaoshirenwu = ref() // 考试任务
const kaoshikemu = ref() // 考试科目
const lrcjfsData = ref([]) // 录入成绩方式

const allXq = ref()
const xsxx = ref({
  xm: '',
  xzbmc: '',
  xh: ''
})// 学生信息
// 方法
// 根据考号查询学生
const xs = ref()
const xvesheng = () => {
  if (ruleForm.value.kh) {
    const info = { kh: ruleForm.value.kh, ksjhid: ruleForm.value.ksjhid, kskmid: ruleForm.value.kmid }
    loadSelect({
      url: '/api/v2/jiaowu/chengjikaoshirenwucankaoxueshengchengji/kaohao',
      data: xs,
      parms: info,
      loadSuccess: function (res) {
        xsxx.value = {
          xm: res.data.xm,
          xzbmc: res.data.bjmc,
          xh: res.data.xh
        }
      }
    })
  }
}
const xveqichaxvn = (e) => {
  if (e === 1) {
    ruleForm.value.ksjhid = ''
    ruleForm.value.kmid = ''
    getkaoshirenwu()
    getkaoshikemu()
  } else if (e === 2) {
    ruleForm.value.kmid = ''
    getkaoshikemu()
  }
}
// 审核状态
const shztData = ref({ list: [] })
loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/shenhezhuangtai', data: shztData })
// 考试任务
const getkaoshirenwu = () => {
  loadSelect({
    url: '/api/v2/jiaowu/kaowukaoshijihua/list',
    data: kaoshirenwu,
    parms: { ksxqid: ruleForm.value.ksxqid, shzt: shztData.value.shenHeTongGuo },
    order: 'ksksrq',
    sort: 'asc',
    loadSuccess: function (res) {
      getkaoshikemu()
    }
  })
}
// 考试科目
const getkaoshikemu = () => {
  loadSelect({
    url: '/api/v2/jiaowu/kaowukaoshijihua/kemu/list',
    data: kaoshikemu,
    parms: { ksjhid: ruleForm.value.ksjhid },
    order: 'kskmmc',
    sort: 'asc'
  })
}

// 提交
const submit = async () => {
  const forms = unref(ruleFormRef)
  if (!forms) return
  await forms.validate()
  const o = { url: '/api/v2/jiaowu/chengjikaoshirenwucankaoxueshengchengji/chengji', data: ruleForm.value }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      successPrompt('成功')
      xsxx.value = { xm: '', xzbmc: '', xh: '' }
      ruleForm.value.kh = ''
      ruleForm.value.fs = ''
      emits('ReturnData')
    } else {
      
      if (res.data) {
        ElMessageBox.confirm('是否覆盖成绩?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ruleForm.value.id = res.data
          submitEditForm({
            url: '/api/v2/jiaowu/chengjikaoshirenwucankaoxueshengchengji/chengji',
            ruleFormRef: unref(ruleFormRef),
            ruleForm: ruleForm.value,
            callback: function (res) {
              xsxx.value = { xm: '', xzbmc: '', xh: '' }
              ruleForm.value.kh = ''
              ruleForm.value.fs = ''
              ruleForm.value.id = ''
              emits('ReturnData')
            }
          })
        })
      } else {
        warningPrompt(res.message)
      }
    }
  })
}

watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value.ksjhid = props.row.ksjhid
      ruleForm.value.kmid = props.row.kmid
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: allXq,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              ruleForm.value.ksxqid = element.id
              getkaoshirenwu()
              loadSelect({
                url: '/api/v2/jiaowu/kaowukaoshijihua/luruchengjifangshi',
                data: lrcjfsData
              })
            }
          })
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
